module.exports = "https://cdn.realtymogul.com/static/media/icon_ladder.1985d737.svg";